























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import DateUtils from '@/common/js/DateUtils'
import Enums from '@/lib/enums'
import { routers } from '@/router/router'
import Quagga from 'quagga'; // ES6

import PageRequest from '@/store/entities/page-request'
import PageResult from '@/store/entities/page-result'
import BackMainLandOrderList from '@/store/entities/order-back-list'
import CreateOrderProductInfo from '@/store/entities/create-order-product';
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(Preview);
class TakePictureInput {
    shipment: string;
    intoPicImageGuid: string;
    intoGoodsPicImageGuid: string;
}
@Component({
    name: "logisticsphoto",
})
export default class OrderScan extends AbpBase {
    resultCode: string = "";
    resultOrderNumber: string = "";
    resultError: string = "";
    imageGuidUrl: string = "";
    imageGoodsGuidUrl: string = "";
    labletext: string = "";
    base64: string = "";
    deliveredLoding: Boolean = false;
    isCheck: Boolean = false;
    processTakePictureInput: TakePictureInput = new TakePictureInput();
    orderData: BackMainLandOrderList = null;
    orderProductInfoList: Array<CreateOrderProductInfo> = [];
    createData() {
        var _this = this;
    }
    rescan() {
        location.reload();
    }
    async takeImageGuidPhoto(e) {//拍照功能---上传头像
        var file = e.target.files[0]//获取文件对象
        //alert(file.size);
        //if (file.size / 1024 > 1024) {
        //    this.$Message.info("图片过大不支持上传");
        //}
        var _this = this;
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
            let image = new Image() //新建一个img标签（还没嵌入DOM节点)
            image.src = e.target.result.toString()
            image.onload = function () {
                let canvas = document.createElement('canvas'),
                    context = canvas.getContext('2d'),
                    imageWidth = image.width / 2,    //压缩后图片的大小
                    imageHeight = image.height / 2,
                    data = ''

                canvas.width = imageWidth
                canvas.height = imageHeight

                context.drawImage(image, 0, 0, imageWidth, imageHeight)
                _this.base64 = canvas.toDataURL('image/jpeg', 0.8);
                _this.LoadImg();

            }

        }
    }
    async LoadImg() {
        var _this = this;
        this.processTakePictureInput.intoPicImageGuid = await this.$store.dispatch({
            type: 'backlogistics/uploadintoPicImg',
            data: { baseString: _this.base64 }
        });

        var data = { imageGuid: this.processTakePictureInput.intoPicImageGuid, url: null };
        this.$store.commit('backlogistics/getImgUrl', data);
        this.imageGuidUrl = data.url;
    }

    async takeGoodsImageGuidPhoto(e) {//拍照功能---上传头像
        var file = e.target.files[0]//获取文件对象
        //alert(file.size);
        //if (file.size / 1024 > 1024) {
        //    this.$Message.info("图片过大不支持上传");
        //}
        var _this = this;
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
            let image = new Image() //新建一个img标签（还没嵌入DOM节点)
            image.src = e.target.result.toString()
            image.onload = function () {
                let canvas = document.createElement('canvas'),
                    context = canvas.getContext('2d'),
                    imageWidth = image.width / 2,    //压缩后图片的大小
                    imageHeight = image.height / 2,
                    data = ''

                canvas.width = imageWidth
                canvas.height = imageHeight

                context.drawImage(image, 0, 0, imageWidth, imageHeight)
                _this.base64 = canvas.toDataURL('image/jpeg', 0.8);
                _this.LoadGoodsImg();

            }

        }
    }
    async LoadGoodsImg() {
        var _this = this;
        this.processTakePictureInput.intoGoodsPicImageGuid = await this.$store.dispatch({
            type: 'backlogistics/uploadintoPicImg',
            data: { baseString: _this.base64 }
        });

        var data = { imageGuid: this.processTakePictureInput.intoGoodsPicImageGuid, url: null };
        this.$store.commit('backlogistics/getImgUrl', data);
        this.imageGoodsGuidUrl = data.url;
    }
    async save() {
        if (this.resultCode == "") {
            this.$Message.error("未获取到快递单号，请重新扫描！");
            return;
        }
        this.processTakePictureInput.shipment = this.resultCode;
        var b = await this.$store.dispatch({
            type: 'backlogistics/SetTakePictureByPhone',
            data: this.processTakePictureInput
        })
        if (b) {
            this.$Message.success('保存成功');
        }
    }
    async delivered() {
        this.deliveredLoding = true;
        await this.$store.dispatch({
            type: 'backorder/ ',
            data: { tradeNo: this.resultCode }
        }).finally(() => {
            this.deliveredLoding = false;
        });
        this.resultCode = '';
        this.$emit('save-success');
    }
    stop() {
        Quagga.stop();
    }

    HideMenu() {
        var _this = this;
        var menu: any = document.querySelector("div[class='sidebar-menu-con']");
        var head: any = document.querySelector("div[class='main-header-con']");
        var page: any = document.querySelector("div[class='single-page-con']");
        if (menu && head && page) {
            head.style.display = "none";
            menu.style.display = "none";
            page.style.top = "0px";
            page.style.left = "0px";
        } else {
            setTimeout(function () { _this.HideMenu() }, 200);
        }
    }
    async created() {

        var shipment = abp.getQueryVariable("shipment");
        if (shipment) {
            this.resultCode = shipment;
        }
        if (abp.isMobile()) {
            abp.hideMenu();
        }


    }
};
